<template>
	<div class="detail">
		<article-edit v-if='isEdit' :close="handleClose" :form="itemForm" :id="reviseId" ></article-edit>
	</div>
</template>

<script>
import { getArticle } from '@/utils/axios.js';	
import ArticleEdit from '@/components/ArticleEdit';
	
export default {
	name: 'mainArticleDetail',
	components: {
		ArticleEdit
	},
	data() {
		return {
			submiting: false, // 正在请求
			list: [], //列表
			pageData: {
				count: 0, // 总条数
				page: 1, // 当前页
				pagecount: 0, // 总页数
				pagesize: 15 // 每页条数
			},
			itemForm: {},
			isEdit: true,
			reviseId: '', //当前选中Id
		};
	},
	
	created() {
		
	},
	mounted() {
		if(this.$route.query.id) {
			this.reviseId = this.$route.query.id
			this.handleReviseRemark(this.$route.query.id)
		}
	},
	watch:{
		'itemForm.title':{
			handler(val){
				if(val && typeof val == 'string') {
					this.itemForm.title = val.replace(/\s+/g,"")
				}
				
			},
			deep:true,
			immediate:true
		},
		'itemForm.source':{
			handler(val){
				if(val && typeof val == 'string') {
					this.itemForm.source = val.replace(/\s+/g,"")
				}
				
			},
			deep:true,
			immediate:true
		},
	},
	methods: {
		// 新增文章
		handleAddArticle() {
			this.reviseId = '',
			this.itemForm = {};
		},
		// 关闭文章编辑并重置表单
		handleClose() {
			this.id = '';
			this.itemForm = {};
		},
		
		//获取单条文章信息
		handleReviseRemark(id) {
			this.reviseId = id;
			getArticle({
				act: 'query',
				id: id
			}).then((res) => {
				if(res.code == 200) {
					this.itemForm = res.data
				}
			})
		},
		// 列表切换
		pageChange(page) {
			this.pageData.page = page;
		}
	}
};
</script>

<style>
	.detail {
		padding: 28px 24px;
	}
</style>
